import React from 'react';

import './disclaimer.styles.scss';

const Disclaimer = () => (
  <div className='disclaimer'>
    <h1 className='disclaimer-title'>Disclaimer</h1>
    <p className='disclaimer-message'>
      We, at tidings, feature articles related to economics and history. <br /><br />Entitlement of opinions is an absolutely essential facet of journalism, but we, at Tidings, believe in unbiased journalism as much as we do in freedom of individual opinion. In light of the above, we would like all of you to know that all opinionated articles, represent the views of the author and do not necessarily reflect the opinions of Tidings itself.
    </p>
  </div>
);

export default Disclaimer;